import React, { useState } from "react";
import axios from "axios";
import "./App.css";

function App() {
  const [data, setData] = useState({});
  const [location, setLocation] = useState("");

  const url = `https://api.openweathermap.org/data/2.5/weather?q=${location}&units=metric&APPID=63f491f7b8c84b4350eb77550f0bb1a8`;
  // const url = `https://api.openweathermap.org/data/2.5/forecast?q=${location}&units=imperial&appid=63f491f7b8c84b4350eb77550f0bb1a8`;
  const searchLocation = (event) => {
    if (event.key === "Enter") {
      axios.get(url).then((response) => {
        setData(response.data);
      });
      setLocation("");
    }
  };

  return (
    <div className="app">
      <div className="search">
        <input
          value={location}
          onChange={(event) => setLocation(event.target.value)}
          onKeyPress={searchLocation}
          placeholder="Enter Loacation"
          type="text"
        />
      </div>
      <div className="container">
        <div className="top">
          <section className="location">
            <p>{data.name}</p>
          </section>
          <section className="temp">
            {data.main ? <h1> {data.main.temp}° C </h1> : null}
          </section>
          <section className="description">
            {data.weather ? <p>{data.weather[0].main}</p> : null}
          </section>
        </div>
        {data.name !== undefined && (
          <div className="bottom">
            <section className="feels">
              <p className="bold"> {data.main.feels_like}° C </p>
              <p>Feels like</p>
            </section>
            <section className="humidity">
              <p className="bold"> {data.main.humidity}% </p>
              <p>Humidity</p>
            </section>
            <section className="wind">
              <p className="bold"> {data.wind.speed}MPH </p>
              <p>Wind Speed</p>
            </section>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
